import { tabs } from "../../utils/kitTabs";

const deviceVersion = sessionStorage.getItem("deviceVersion") || "0.0.0";
// const zingVersion = sessionStorage.getItem('zingVersion') || '0.0.0'
const connectedDevice = sessionStorage.getItem("connectedDevice");

var deviceInitialState = {
  aiVersion: "",
  connectedDevice: connectedDevice,
  deviceVersion: deviceVersion,
  isMemoryPresent: false,
  isArmError: false,
  is2In1Sensor: false,
  deviceMismatched: {},
  language: "English",
  plodeNativeData: {
    mountPoint: "",
  },
  kitSelection: {
    activeTab: tabs[0].id,
    selectedKit: {},
  },
};
const reduxDeviceStore = sessionStorage.getItem("reduxDeviceStore");
try {
  if (reduxDeviceStore) {
    deviceInitialState = JSON.parse(reduxDeviceStore);
  }
} catch (e) {
  console.log("ERROR", e);
}

const deviceReducer = (state = deviceInitialState, action) => {
  switch (action.type) {
    case "DEVICE_DETAILS": {
      console.log("redux1", action.payload);
      let data;
      // if (['Ace', 'Hexapod'].includes(action.payload.connectedDevice)) {
      data = {
        ...state,
        connectedDevice: action.payload.connectedDevice,
        deviceVersion: action.payload.deviceVersion,
        // zingVersion: '0.0.0',
      };
      // sessionStorage.setItem('zingVersion', '0.0.0')
      // } else {
      //     data = {
      //         ...state,
      //         connectedDevice: action.payload.connectedDevice,
      //         deviceVersion: '0.0.0',
      //         zingVersion: action.payload.zingVersion,
      //     }
      //     sessionStorage.setItem('deviceVersion', '0.0.0')
      // }
      sessionStorage.setItem("reduxDeviceStore", JSON.stringify(data));
      return data;
    }
    case "DEVICE_MISMATCH": {
      console.log("redux2", action.payload);
      let {
        isMemoryPresent = state.isMemoryPresent,
        isArmError = state.isArmError,
        is2In1Sensor = state.is2In1Sensor,
        plodeNativeData = {
          mountPoint: "",
        },
      } = action?.payload ?? {};

      let data = {
        ...state,
        deviceMismatched: action.payload.deviceMismatched,
        isMemoryPresent: isMemoryPresent,
        isArmError: isArmError,
        is2In1Sensor: is2In1Sensor,
        plodeNativeData: plodeNativeData,
      };
      sessionStorage.setItem("reduxDeviceStore", JSON.stringify(data));
      return data;
    }
    case "LANGUAGE_SELECT": {
      console.log("redux2", action.payload);
      let data = {
        ...state,
        language: action.payload.language,
      };
      sessionStorage.setItem("reduxDeviceStore", JSON.stringify(data));
      return data;
    }
    case "PLODE_NATIVE_DATA": {
      console.log("redux2", action.payload);
      let data = {
        ...state,
      };
      data.plodeNativeData = action.payload;
      sessionStorage.setItem("reduxDeviceStore", JSON.stringify(data));
      return data;
    }

    case "SET_AI_VERSION": {
      let data = {
        ...state,
      };
      data.aiVersion = action.payload;
      sessionStorage.setItem("reduxDeviceStore", JSON.stringify(data));
      return data;
    }
    case "SET_SELECTED_KIT": {
      let data = {
        ...state,
      };
      data.kitSelection.selectedKit = {
        ...data.kitSelection.selectedKit,
        ...action.payload,
      };
      sessionStorage.setItem("reduxDeviceStore", JSON.stringify(data));
      return data;
    }
    case "SET_ACTIVE_TAB": {
      let data = {
        ...state,
      };
      data.kitSelection.activeTab = action.payload;

      sessionStorage.setItem("reduxDeviceStore", JSON.stringify(data));
      return data;
    }
    default:
      return state;
  }
};

export default deviceReducer;
